import { IPcr } from '../../../features/pcr/store/pcr.types'
import Logger from '../../../services/logger.service'

export const addVitalsPainQuality = (pcr: any): IPcr => {
  try {
    if (pcr?.patient?.patientVitals && pcr.patient.patientVitals.length > 0) {
      pcr.patient.patientVitals.forEach((vital: any) => {
        if (vital && vital.painQuality === undefined) {
          vital.painQuality = null
        }
      })
    }

    return pcr
  } catch (error) {
    Logger.error(`Error executing schema upgrade rule addVitalsPainQuality: ${error}`)
    throw error
  }
}
